import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function Hero() {
  return <header className="border-b-4 border-gold bg-navy px-3 pb-4 pt-3 text-center sm:px-6 sm:pb-5 sm:pt-4" data-id="element-82" data-mp="eiv62y7sfcld">
      <h1 className="font-heading text-[0.9rem] font-extrabold uppercase leading-[1.15] tracking-wide text-white sm:text-[1.3rem]" data-id="element-83" data-mp="9llat1xpw6pm">
        THE COMPLETE VISUAL STUDY SYSTEM FOR{' '}
        <span className="text-gold" data-id="element-84" data-mp="129qrndlnhbk6">SURGICAL INSTRUMENTS</span>
      </h1>
      <p className="mt-1.5 font-display text-[1.4rem] font-bold uppercase leading-[1.06] text-white sm:text-[2.3rem]" data-id="element-85" data-mp="xanoxzt57hfd">
        STOP MEMORIZING RANDOM NAMES. <span className="text-gold" data-id="element-86" data-mp="s9q6dm480ldc">START RECOGNIZING THE INSTRUMENT.</span>
      </p>
      <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-[1.35] text-white/85 sm:text-[0.95rem]" data-id="element-87" data-mp="nb6njukxbpp7">
        Identify surgical instruments, understand their visual characteristics, compare similar
        designs, and recognize functional families and surgical sets—all in one organized visual
        study system.
      </p>

      <BoxImage className="mx-auto mt-2 max-w-[270px] sm:max-w-[360px]" data-id="element-88" data-mp="3j6fxtot8hbdb" />

      <div className="mx-auto mt-2 max-w-md" data-id="element-89" data-mp="3o6amdlpjdov7">
        <CTAButton label="🚀 YES! I WANT MY VISUAL ATLAS NOW" data-id="element-90" data-mp="39acx8ne15ksh" />
        <p className="mt-2 font-heading text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-91" data-mp="39a36uyp2pbm9">
          🛡️ 7-Day Money-Back Guarantee — Zero Risk
        </p>
      </div>
    </header>;
}